var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-item"},[_c('DropDown',{attrs:{"title":_vm.title,"mainslug":_vm.slug,"content":_vm.content}})],1),_c('router-view',{attrs:{"content":_vm.allContent,"filtered":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }